import React from "react";
import styled from "styled-components";
import { compose, lifecycle, withState } from "recompose";
import { Cta } from "../common/Button";
import { ModalTitle } from "../common/Modal";

const CompletedStep = props => {
  const { videoUrl, onDownload } = props;
  return (
    <Layout>
      <ModalTitle>Your video is ready!</ModalTitle>
      <VideoContainer>
        <VideoPlayer url={videoUrl} />
      </VideoContainer>
      <ButtonContainer>
        <Cta onClick={onDownload}>Download</Cta>
      </ButtonContainer>
    </Layout>
  );
};

const MODAL_MAX_HEIGHT = 650;
const getVideoSize = () => {
  const heightUsed = 220;
  let webViewHeight = window.innerHeight - heightUsed;
  if (window.innerWidth >= 640 && webViewHeight > MODAL_MAX_HEIGHT - heightUsed) {
    webViewHeight = MODAL_MAX_HEIGHT - heightUsed;
  }
  let webViewWidth = webViewHeight / (16 / 9);
  return { width: webViewWidth, height: webViewHeight };
};

const { height: VIDEO_HEIGHT, width: VIDEO_WIDTH } = getVideoSize();

const ButtonContainer = styled.div`
  width: 80%;
`;

const VideoPlayer = ({ url }) => (
  <VideoComponent
    loop
    muted
    autoPlay
    playsInline
    preload="auto"
    controls
  >
    <source src={url} type="video/mp4" />
  </VideoComponent>
);

const VideoContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
  width:${VIDEO_WIDTH}px;
  height:${VIDEO_HEIGHT}px;
`;

/* height: 384px; */
/* width: 216px; */
const VideoComponent = styled.video`
  width:${VIDEO_WIDTH}px;
  height:${VIDEO_HEIGHT}px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 10px 5px -6px, rgba(0, 0, 0, 0.2) 0px 0px 5px -3px;
  /* max-width: 65%;
  max-height: 720px;
  @media (max-height: 568px) {
    max-height: 320px;
    width: 100%;
  } */
  background-image: url("/assets/images/9load.gif");
  background-size: 48px 48px;
  background-position: center center;
  background-repeat: no-repeat;
  border: none;
`;

const Layout = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const enhancer = compose(
  lifecycle({
    componentDidMount() {
      if (window.gtag) {
        window.gtag("event", "page_view", { title: "Download Video" });
      }
    },
  })
);

export default enhancer(CompletedStep);
